export const ROUTES = {
    HOME: "/",
    REPAIR_WORK: "/repair-work",
    PRIVACY_POLICY: "/privacy-policy",
    STATISTICS: "/statistics",
    NORMATIVE_BASE: "/normative-base",
    NEWS: "/news",
    SINGLE_NEWS: "/news/:id",
    REQUESTS: "/requests",
    NOT_FOUND: "*",
  };
